import { useLocalNum } from "@faire/web--source/common/localization";
import { useQuery as useProductReviewsQuery } from "@faire/web-api--source/api/product/productToken/brand-reviews-summary/get-hooks";
import { useMemo } from "react";
export var useBrandReviewSummary = function(productToken) {
    var _useProductReviewsQuery = useProductReviewsQuery(productToken, {
        refetchOnMount: false
    }), reviewsSummary = _useProductReviewsQuery.data;
    var localNum = useLocalNum().localNum;
    var overallRatingText = useMemo(function() {
        return localNum(reviewsSummary === null || reviewsSummary === void 0 ? void 0 : reviewsSummary.brand_overall_rating, {
            minimumSignificantDigits: 2,
            maximumSignificantDigits: 2
        });
    }, [
        reviewsSummary,
        localNum
    ]);
    var numberOfReviews = useMemo(function() {
        return reviewsSummary === null || reviewsSummary === void 0 ? void 0 : reviewsSummary.brand_total_reviews;
    }, [
        reviewsSummary
    ]);
    return {
        overallRatingText: overallRatingText,
        numberOfReviews: numberOfReviews
    };
};
